import React, { Suspense, useEffect } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import './scss/style.scss'
import UseToken from './hooks/UseToken'
import 'react-notifications/lib/notifications.css'
import { NotificationContainer } from 'react-notifications'
import PushNotifications from './services/PushNotifications'
import PWAInstallPrompt from './components/PWAInstallPrompt'
const MonthlyOfferPublic = React.lazy(() => import('./views/marketing/MonthlyOfferPublic'))

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
const SendRecoveryPassword = React.lazy(() =>
  import('./views/pages/forget-password/SendRecoveryPassword'),
)
const RegeneratePassword = React.lazy(() =>
  import('./views/pages/forget-password/RegeneratePassword'),
)

const App = () => {
  const { setToken } = UseToken()
  const tokenString = sessionStorage.getItem('token')

  // Push notifications Fase 2 (Roger 29-may-2026): tras login, pedir permiso
  // y suscribir el browser al servicio push. Solo se ejecuta una vez por sesión
  // y es no-op si el navegador no soporta o el usuario ya rechazó.
  // Must be before any early return (react-hooks/rules-of-hooks).
  useEffect(() => {
    if (!tokenString) return
    const workerCode = (sessionStorage.getItem('worker_code') || '').replaceAll('"', '')
    const svc = new PushNotifications()
    if (!svc.isSupported()) {
      console.log('[App] push not supported in this browser')
      return
    }
    const t = setTimeout(() => {
      console.log('[App] triggering ensureSubscribed for worker_code=', workerCode)
      svc.ensureSubscribed(workerCode).catch((e) => {
        console.error('[App] ensureSubscribed catch:', e)
      })
    }, 5000)
    return () => clearTimeout(t)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Roger 30-may-2026: vista pública oferta del mes — sin login.
  // Detectamos antes del redirect a / si la URL hash incluye /oferta-mes/.
  const hashPath = window.location.hash || ''
  const isPublicOffer = /^#\/oferta-mes\//.test(hashPath)

  if (!tokenString && !isPublicOffer) {
    if (window.location.pathname !== '/') {
      window.open('/', '_self')
    }
    return (
      <HashRouter>
        <Suspense fallback={loading}>
          <Routes>
            <Route exact path="/" element={<Login setToken={setToken} />} />
            <Route exact path="/register" element={<Register />} />
            <Route exact path="/send-recovery-password" element={<SendRecoveryPassword />} />
            <Route exact path="/regenerate-password" element={<RegeneratePassword />} />
          </Routes>
          <NotificationContainer />
        </Suspense>
      </HashRouter>
    )
  }

  if (!tokenString && isPublicOffer) {
    return (
      <HashRouter>
        <Suspense fallback={loading}>
          <Routes>
            <Route path="/oferta-mes/:slug" element={<MonthlyOfferPublic />} />
            <Route path="*" element={<Login setToken={setToken} />} />
          </Routes>
          <NotificationContainer />
        </Suspense>
      </HashRouter>
    )
  }

  return (
    <HashRouter>
      <Suspense fallback={loading}>
        <Routes>
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route path="*" name="Admin Sirvent Productes" element={<DefaultLayout />} />
        </Routes>
        <NotificationContainer />
        <PWAInstallPrompt />
      </Suspense>
    </HashRouter>
  )
}

export default App
